export default {
    data() {
        return {
            notifications: [],
            notificationIdCounter: 0
        }
    },
    methods: {
        showAlertMessage(text, type = 'info', duration = 5000, position = 'top-right') {
            const notification = {
                id: ++this.notificationIdCounter,
                text,
                type,
                position,
            };

            this.notifications.push(notification);

            if (duration > 0) {
                setTimeout(() => this.dismissNotification(notification.id), duration);
            }
        },
        dismissNotification(id) {
            const index = this.notifications.findIndex(n => n.id === id);
            if (index > -1) {
                this.notifications.splice(index, 1);
            }
        },
        clearAllNotifications() {
            this.notifications = [];
        }
    }
}


// WEBPACK FOOTER //
// ./src/Assets/mixins/notifications.js